export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:beforeMount', () => {
    ;(function () {
      const originalWarn = console.warn

      function customWarn(message: string, ...args: unknown[]) {
        console.warn = originalWarn

        if (/use(Lazy)?Query/.test(message)) {
          useDatadog().log('warn', {
            message,
            messageContext: { useQuery: { url: useRoute().fullPath } },
          })
        }

        originalWarn.apply(console, [message, ...args])

        console.warn = customWarn
      }

      console.warn = customWarn
    })()
  })
})
